import { graphql } from 'src/gql'
import { PositionSummaryReportQueryVariables } from 'src/gql/graphql'
import { GetTData } from 'src/gql/helpers'
import { useGraphQL } from 'src/hooks/useGraphQL'

const document = graphql(/* graphql */`
  query positionSummaryReport($id: Int!) {
    reporting {
      positionSummary(_id: $id) {
        _id
        report
      }
    }
  }
`)

type TData = GetTData<typeof document>
export type PositionSummaryReport = NonNullable<NonNullable<NonNullable<TData>['reporting']>['positionSummary']>['report']

const usePositionSummaryReport = (id: PositionSummaryReportQueryVariables['id']): PositionSummaryReport | undefined => {
  const { data } = useGraphQL(document, { id })
  return data?.reporting?.positionSummary.report
}

export { usePositionSummaryReport, document as positionSummaryReportDocument }
